import React, { Component } from 'react';
import $ from 'jquery';
import { findDOMNode } from 'react-dom';

export default class Sidekicks extends Component {

toggle = () => {
    let toggle = findDOMNode(this.refs.toggle);
    $(toggle).toggle();
}

	render() {
		return (
			<div>
                <iframe id="video" ref="toggle" src="https://www.youtube.com/embed/llm_Loqq1Qs" 
                title="Sidekicks"></iframe>
				<button
					type="button"
					className="btn sidekicks"
					onClick={this.toggle}
				>
					Sidekicks
				</button>
			</div>
		);
	}
}